export const Form555 = {
    getFormName() {
        return {



            team_member_name: '',
            supervisor_name: '',
            date: '',
            quater: '',
            year: '',
            notes: '',
            conversationId: 0,
            human_resources: 'N',
            human_resources_notes: '',
            vp_construction: 'N',
            vp_construction_notes: '',
            president: 'N',
            president_notes: '',





            section_2: [
                {
                    title: '1',
                    description: '',
                },
                {
                    title: '2',
                    description: '',
                },
                {
                    title: '3',
                    description: '',
                },
                {
                    title: '4',
                    description: '',
                },
                {
                    title: '5',
                    description: '',
                },
            ],

            section_3: [
                {
                    title: '1',
                    description: '',
                    embracing_core_values: '',
                },
                {
                    title: '2',
                    description: '',
                    embracing_core_values: '',
                },
                {
                    title: '3',
                    description: '',
                    embracing_core_values: '',
                },

            ],

            section_4: [
                {
                    title: '1',
                    description: '',
                    embracing_core_values: '',
                },
            ],

            section_5: [
                {
                    title: '1',
                    description: '',
                },

            ],

            section_6: [
                {
                    my_total: '',
                    measurable_track: '',
                    measurables_comments: '',
                },

            ],

            section_7: [
                {
                    keeping_expectations: '',
                    communicating_well: '',
                    meeting_pulse: '',
                    quarterly_conversations: '',
                },

            ],

            section_8: [
                {
                    name: '',
                    teamwork: '',
                    committed_to_excellence: '',
                    we_always_do: '',
                    gets_it: '',
                    wants_it: '',
                    has_the_capacity: '',
                },
                {
                    name: '',
                    teamwork: '',
                    committed_to_excellence: '',
                    we_always_do: '',
                    gets_it: '',
                    wants_it: '',
                    has_the_capacity: '',
                },
                {
                    name: '',
                    teamwork: '',
                    committed_to_excellence: '',
                    we_always_do: '',
                    gets_it: '',
                    wants_it: '',
                    has_the_capacity: '',
                },
            ],

            section_9: [
                // `section_9.0.whats_working_title`
                {
                    whats_working_title: '',
                    whats_working_desc: '',
                    whats_not_working_title: '',
                    whats_not_working_desc: '',
                    next_steps_title: '',
                    next_steps_desc: '',
                    provide_feedback_title: '',
                    provide_feedback_desc: '',
                    improve_personally_professionally_title: '',
                    improve_personally_professionally_desc: '',
                },

            ],

            section_10: [
                {
                    title: '',
                    description: "",
                    short_desc: '',

                },
                {
                    title: '',
                    description: "",
                    short_desc: '',

                },
                {
                    title: '',
                    description: "",
                    short_desc: '',

                },
                {
                    title: '',
                    description: "",
                    short_desc: '',

                },
            ],
            section_11: [
                {
                    love_great_at_desc: '',
                    like_good_at_desc: "",
                    dont_like_good_at_desc: '',
                    dont_like_not_good_at_desc: '',
                    notes: '',
                },
            ],

        }
    },

    getPerformanceForm() {
        return {



            team_member_name: '',
            supervisor_name: '',
            date: '',
            year: '',
            notes: '',
            conversationId: 0,

            human_resources: 'N',
            human_resources_notes: '',
            vp_construction: 'N',
            vp_construction_notes: '',
            president: 'N',
            president_notes: '',

            // strengths_and_accomplishments: '',
            // performance_areas_which_need_improvement: '',
            // plan_of_action_toward_improved_performance: '',
            // employee_comments: '',
            whats_working: '',
            signature1: '',
            signature2: '',


            most_proud:'',
            whats_working_title:'',
            whats_not_working_title:'',
            next_steps_title:'',
            provide_feedback_title:'',
            improve_personally_professionally_title:'',

            section_2: [
                {
                    title: '1',
                    description: '',
                    rocks_done:'N'
                },
                {
                    title: '2',
                    description: '',
                    rocks_done:'N'
                },
                {
                    title: '3',
                    description: '',
                    rocks_done:'N'
                },
                {
                    title: '4',
                    description: '',
                    rocks_done:'N'
                },
                {
                    title: '5',
                    description: '',
                    rocks_done:'N'
                },
            ],

            section_3: [
                {
                    title: '1',
                    description: '',
                    embracing_core_values: '',
                },
                {
                    title: '2',
                    description: '',
                    embracing_core_values: '',
                },
                {
                    title: '3',
                    description: '',
                    embracing_core_values: '',
                },

            ],

            section_4: [
                {
                    title: '1',
                    description: '',
                    embracing_core_values: '',
                },
            ],

            section_5: [
                {
                    title: '1',
                    description: '',
                    self_scorer:'',
                    supervisor_score:'',
                },

            ],

            section_6: [
                {
                    my_total: '',
                    measurable_track: '',
                    measurables_comments: '',
                },

            ],

            section_7: [
                {
                    keeping_expectations: '',
                    communicating_well: '',
                    meeting_pulse: '',
                    quarterly_conversations: '',
                },

            ],

            section_8: [
                {
                    name: '',
                    teamwork: '',
                    committed_to_excellence: '',
                    we_always_do: '',
                    gets_it: '',
                    wants_it: '',
                    has_the_capacity: '',
                },
                {
                    name: '',
                    teamwork: '',
                    committed_to_excellence: '',
                    we_always_do: '',
                    gets_it: '',
                    wants_it: '',
                    has_the_capacity: '',
                },
                {
                    name: '',
                    teamwork: '',
                    committed_to_excellence: '',
                    we_always_do: '',
                    gets_it: '',
                    wants_it: '',
                    has_the_capacity: '',
                },
            ],

            section_9: [
                // `section_9.0.whats_working_title`
                {
                    // whats_working_title: '',
                    // whats_working_desc: '',
                    // whats_not_working_title: '',
                    // whats_not_working_desc: '',
                    // next_steps_title: '',
                    // next_steps_desc: '',
                    // provide_feedback_title: '',
                    // provide_feedback_desc: '',
                    // improve_personally_professionally_title: '',
                    // improve_personally_professionally_desc: '',

                    strengths_and_accomplishments: '',
                    performance_areas_which_need_improvement: '',
                    plan_of_action_toward_improved_performance: '',
                    employee_comments: '',
                    // whats_working: '',
                    // signature1: '',
                    // signature2: '',
                },

            ],

            section_10: [
                {
                    title: '',
                    description: "",
                    short_desc: '',

                },
                {
                    title: '',
                    description: "",
                    short_desc: '',

                },
                {
                    title: '',
                    description: "",
                    short_desc: '',

                },
                {
                    title: '',
                    description: "",
                    short_desc: '',

                },
            ],
            section_11: [
                {
                    love_great_at_desc: '',
                    like_good_at_desc: "",
                    dont_like_good_at_desc: '',
                    dont_like_not_good_at_desc: '',
                    notes: '',
                },
            ],



        }
    },




}